/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description File Primary Claim button
 */
import { Button, Dropdown } from 'antd';
import { Down } from '@icon-park/react';
import { useNavigate } from 'react-router-dom';

import { getFilePrimaryClaimPath } from 'utils/router';
import { CLAIM_TYPES } from 'app-constants/claims/claimRequest';

const FilePrimaryClaim: React.FC = () => {
	const navigate = useNavigate();

	const handleClick = (type: ClaimFiling.IClaimType) => {
		navigate(getFilePrimaryClaimPath(type));
	};

	return (
		<Dropdown
			menu={{
				items: [
					{
						key: CLAIM_TYPES.institutional.value,
						label: CLAIM_TYPES.institutional.label,
						onClick: () => handleClick(CLAIM_TYPES.institutional.value),
						'data-testid': 'cf-file-claim-institutional',
					},
					{
						key: CLAIM_TYPES.professional.value,
						label: CLAIM_TYPES.professional.label,
						onClick: () => handleClick(CLAIM_TYPES.professional.value),
						'data-testid': 'cf-file-claim-professional',
					},
				],
				className: 'min-w-[180px]',
			}}
		>
			<Button type='primary' data-testid='cf-file-claim-btn'>
				{'File Primary Claim'}
				<Down />
			</Button>
		</Dropdown>
	);
};

export default FilePrimaryClaim;
